<template>
  <SpecialEventPackage
    v-if="valentinesEvent"
    class="buy-credits__item--sale-event"
    :shopPackage="shopPackage"
    :buttonLoading="buttonLoading"
    :price="price"
    :bonusAmount="bonusAmount"
    @buy="emitBuy"
  >
    <div class="card__icon">
      <img src="/img/viluu/payment/package_val.png" alt="">
    </div>
  </SpecialEventPackage>

  <SpecialEventPackage
    v-else-if="xmasEvent"
    class="buy-credits__item--sale-xmas"
    :shopPackage="shopPackage"
    :buttonLoading="buttonLoading"
    :price="price"
    :bonusAmount="bonusAmount"
    @buy="emitBuy"
  >
    <div class="card__icon card__icon">
      <img src="/img/viluu/payment/package_xmas.svg" alt="">
    </div>

    <div style="position: absolute; bottom: -8px">
      <img src="/img/viluu/payment/package_snow.svg" alt="">
    </div>
  </SpecialEventPackage>


    <SpecialEventPackage
        v-else-if="meEvent"
        class="buy-credits__item--sale-me"
        :shopPackage="shopPackage"
        :buttonLoading="buttonLoading"
        :price="price"
        :bonusAmount="bonusAmount"
        @buy="emitBuy"
    >
        <div class="card__icon">
            <div class="sale-me" style="position: absolute">SALE!</div>
            <img style="position: absolute;max-width: 65px; margin-top: 33px;" src="/img/viluu/payment/football.png" alt="">
        </div>

        <div style="position: absolute; bottom: -11px; ">
            <img style="height: 25px" src="/img/viluu/payment/grass.png" alt="">
        </div>
    </SpecialEventPackage>

  <DefaultPackage
    v-else
    :shopPackage="shopPackage"
    :buttonLoading="buttonLoading"
    :price="price"
    :bonusAmount="bonusAmount"
    @buy="emitBuy"
  >
  </DefaultPackage>
</template>

<script>
import SpecialEventPackage from './Package/SpecialEventPackage.vue';
import DefaultPackage from './Package/DefaultPackage';

export default {
  name: 'PackageElement',
  components: { DefaultPackage, SpecialEventPackage },
  props: {
    shopPackage: Object,
    fee: Number,
    voucher: Object,
    loading: Boolean,
  },
  data() {
    return {
      buttonLoading: false
    };
  },
  computed: {
    valentinesEvent: function () {
      // return this.shopPackage.id === 17;
      const currentTimestamp = parseInt(new Date().getTime());
      // 1676329200000 - Mon Feb 13 2023 23:00:00 GMT+0000
      // 1676588400000 - Thu Feb 16 2023 23:00:00 GMT+0000
      const isDateEvent = currentTimestamp >= 1676329200000 && currentTimestamp <= 1676588400000;

      return this.shopPackage.is_sale
        && isDateEvent
        && !this.shopPackage.is_starter
        && this.shopPackage.unit === 'coin'
        && this.shopPackage.type !== 'last-chance';
    },
    xmasEvent: function () {
      // return this.shopPackage.id === 11;
      const currentTimestamp = parseInt(new Date().getTime());
      // 1702899495000 - Monday, 18 December 2023 11:38:15
      // 1704063599000 - Sunday, 31 December 2023 22:59:59
      const isDateEvent = currentTimestamp >= 1702899495000 && currentTimestamp <= 1704063599000;

      return this.shopPackage.is_sale
        && isDateEvent
        && !this.shopPackage.is_starter
        && this.shopPackage.unit === 'coin'
        && this.shopPackage.type !== 'last-chance';
    },
    meEvent: function () {
      // return this.shopPackage.id === 11;
      const currentTimestamp = parseInt(new Date().getTime());
      // 1702899495000 - Monday, 18 December 2023 11:38:15
      // 1704063599000 - Sunday, 31 December 2023 22:59:59
      const isDateEvent = currentTimestamp >= 702899495000 && currentTimestamp <= 2704063599000;

      return this.shopPackage.is_sale
              && isDateEvent
              && !this.shopPackage.is_starter
              && this.shopPackage.unit === 'coin'
              && this.shopPackage.type !== 'last-chance';
    },
    price: function () {
      const price = (Math.round(this.shopPackage.price * (1 + (this.fee / 100))) / 100).toFixed(2);
      this.$emit('price', price);
      return price;
    },
    bonusAmount: function () {
      if (this.voucher && this.voucher.type === window.globals.voucher.type_percent) {
        return Math.ceil(this.shopPackage.amount * (this.voucher.discount / 100));
      }

      if (this.voucher && this.voucher.type === window.globals.voucher.type_quantity) {
        return this.voucher.discount;
      }

      return null;
    },
  },
  watch: {
    price: function (newVal) {
      this.$emit('price', newVal);
    },
    loading: function (newVal) {
      if (newVal === false) {
        this.buttonLoading = false;
      }
    },
  },
  methods: {
    emitBuy: function () {
      this.buttonLoading = true;
      this.$emit('buy', { package_id: this.shopPackage.id, price: this.price });
    },
  },
  mounted() {
  }
};
</script>
